import { TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN } from '@monorepo/types';
import * as _ from 'lodash';

export const MACHINE_TRANSFER_SIBLING_FACTORY_FORM_MODEL = {
  createModel: (factoryDropdownInfo: TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'DROPDOWN',
            value: '',
            options: factoryDropdownInfo.factoryIds.map((factoryId) => {
              return {
                value: factoryId,
              };
            }),
          },
          metadata: {
            keyName: 'factoryId',
            label: 'Factory ID',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN',
            value: '',
            options: factoryDropdownInfo.transferReasons.map((reason) => {
              return {
                value: reason,
              };
            }),
          },
          metadata: {
            keyName: 'transferReason',
            label: 'Transfer Reason',
            isRequired: true,
          },
        },
      ],
      isValid: false,
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
